import React from 'react';
import { ChevronDown } from 'lucide-react';

const STATUS_OPTIONS = [
  { value: 'NEW', label: 'Nowa' },
  { value: 'IN_PROGRESS', label: 'W realizacji' },
  { value: 'PENDING', label: 'Oczekująca' },
  { value: 'ASSIGNED', label: 'Przekazana' },
  { value: 'RETURNED', label: 'Zwrócona' },
  { value: 'SIGNED', label: 'Podpisana' },
  { value: 'DONE', label: 'Zaksięgowana' },
];

const getStatusLabel = (status) => {
  const option = STATUS_OPTIONS.find((o) => o.value === status);
  return option ? option.label : status;
};

const getStatusColor = (status, isModern) => {
  if (isModern) {
    const modernColors = {
      NEW: 'bg-blue-50 text-blue-700 border border-blue-100',
      IN_PROGRESS: 'bg-amber-50 text-amber-700 border border-amber-100',
      PENDING: 'bg-rose-50 text-rose-700 border border-rose-100',
      ASSIGNED: 'bg-violet-50 text-violet-700 border border-violet-100',
      RETURNED: 'bg-orange-50 text-orange-700 border border-orange-100',
      DONE: 'bg-emerald-50 text-emerald-700 border border-emerald-100',
      SIGNED: 'bg-sky-50 text-sky-700 border border-sky-100',
    };
    return modernColors[status] || 'bg-gray-50 text-gray-600 border border-gray-100';
  }
  const colors = {
    NEW: 'bg-green-600 text-white border border-green-700',
    IN_PROGRESS: 'bg-orange-500 text-white border border-orange-600',
    PENDING: 'bg-amber-500 text-white border border-amber-600',
    ASSIGNED: 'bg-yellow-500 text-white border border-yellow-600',
    RETURNED: 'bg-orange-50 text-orange-700 border border-orange-200',
    DONE: 'bg-green-50 text-green-700 border border-green-200',
    SIGNED: 'bg-blue-500 text-white border border-blue-600',
  };
  return colors[status] || 'bg-gray-50 text-gray-700 border border-gray-200';
};

const InvoiceStatusCell = ({
  status,
  isDeleted = false,
  isSuperAdmin = false,
  isModern = false,
  isUpdating = false,
  onStatusChange,
}) => {
  if (isDeleted) {
    return (
      <span className="px-1.5 sm:px-2 py-0.5 sm:py-1 inline-flex text-[10px] sm:text-xs leading-4 sm:leading-5 font-semibold rounded-full bg-red-300 text-red-800">
        USUNIĘTA
      </span>
    );
  }

  const colorClasses = getStatusColor(status, isModern);

  if (!isSuperAdmin || !onStatusChange) {
    return (
      <span className={`px-1.5 sm:px-2 py-0.5 sm:py-1 inline-flex text-[10px] sm:text-xs leading-4 sm:leading-5 font-semibold rounded-full ${colorClasses}`}>
        {getStatusLabel(status)}
      </span>
    );
  }

  return (
    <div className="relative inline-flex items-center">
      <select
        value={status || ''}
        disabled={isUpdating}
        onChange={(e) => onStatusChange(e.target.value)}
        title="Kliknij, aby zmienić status faktury"
        className={`appearance-none pl-2 pr-6 py-0.5 sm:py-1 text-[10px] sm:text-xs leading-4 sm:leading-5 font-semibold rounded-full cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-60 disabled:cursor-wait ${colorClasses}`}
      >
        {STATUS_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <ChevronDown className="absolute right-1.5 h-3 w-3 pointer-events-none opacity-70" />
    </div>
  );
};

export default InvoiceStatusCell;
